var render = function render(_c,_vm){return _c('div',{staticClass:"product_promo",class:_vm.props.warehousePromo.view.cssClass},[_c('div',{staticClass:"promo_body",domProps:{"innerHTML":_vm._s(_vm.props.warehousePromo.view.body)}}),_c('div',{staticClass:"promo_footer",domProps:{"innerHTML":_vm._s(_vm.props.warehousePromo.view.footer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }